import { FieldType, IField } from 'types/graphql'

export const getFieldValue = (value: any, field: IField) => {
  switch (field.fieldType) {
    case FieldType.PickList: {
      return value?.label
    }
    case FieldType.Lookup: {
      return value?.label
    }
    case FieldType.Address: {
      return value?.value?.address
    }
    case FieldType.Date: {
      return value
    }
    default: {
      return value
    }
  }
}
